import { S_LANG, S_SITE_INFO, webStorage } from "./webStorage";
import siteApi from "./siteApi";

/**
 * @return {Promise<{country: *, preferredLanguage: *, datePlaceholder, dateFormat, organization: *, language: *}|*>}
 */
const getSiteInfo = async (lang = "") => {
  if (!lang) {
    lang = webStorage.get(S_LANG) || "en";
  }
  const siteInfo = webStorage.get(S_SITE_INFO) || [];
  const result = siteInfo.find(e => e.lang === lang);
  if (result) {
    return result.data;
  } else {
    // let {
    //   Data: { CountryLang, CountryOrg, CountryleadsLang, CountryLocal, DateFormat, DatePlaceholder }
    // } = {await siteApi.site.get({
    //   key: lang
    // })};
    let CountryLang, CountryOrg, CountryleadsLang, CountryLocal, DateFormat, DatePlaceholder;
    // console.log(CountryLang, CountryOrg, CountryleadsLang, CountryLocal);
    const data = {
      language: CountryLang || "",
      organization: CountryOrg || "",
      preferredLanguage: CountryleadsLang || "",
      country: CountryLocal || "",
      dateFormat: DateFormat || "yyyy-MM-dd",
      datePlaceholder: DatePlaceholder || "yyyy-MM-dd"
    };
    siteInfo.push({
      lang,
      data
    });
    webStorage.set(S_SITE_INFO, siteInfo);
    return data;
  }
};
export default getSiteInfo;
